import { render, staticRenderFns } from "./collectList.vue?vue&type=template&id=6e9593fd&scoped=true&"
import script from "./collectList.vue?vue&type=script&lang=js&"
export * from "./collectList.vue?vue&type=script&lang=js&"
import style0 from "./collectList.vue?vue&type=style&index=0&id=6e9593fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9593fd",
  null
  
)

export default component.exports